import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const TableToExcelButton = ({
  buttonId = "",
  tableId,
  filename = "export",
  sheet = "Sheet1",
  className = "",
  label,
  style = {},
  hidden = false,
}) => {
  const exportToExcel = () => {
    const table = document.getElementById(tableId);
    if (!table) return console.error(`Table with id "${tableId}" not found`);

    const wb = XLSX.utils.table_to_book(table, { sheet });
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `${filename}.xlsx`
    );
  };

  return (
    <button
      onClick={exportToExcel}
      id={buttonId}
      className={className}
      style={{ display: hidden ? "none" : undefined, ...style }}
    >
      {label}
    </button>
  );
};

export default TableToExcelButton;
